import { render, staticRenderFns } from "./EmployeeList.vue?vue&type=template&id=4ff35a49&scoped=true"
import script from "./EmployeeList.vue?vue&type=script&lang=js"
export * from "./EmployeeList.vue?vue&type=script&lang=js"
import style0 from "./EmployeeList.vue?vue&type=style&index=0&id=4ff35a49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff35a49",
  null
  
)

export default component.exports